import { Grid, Box } from '@material-ui/core';
import {
  CallBackIcon,
  CheckedCalendarIcon,
  CheckedCircleIcon,
  DocumentIcon,
  MagnifyIcon,
  OnAvailIcon,
  PointerIcon,
  SelectedIcon,
  TimesCircleIcon,
  Typography,
  UserBoxIcon,
  UserIcon,
  ViewedIcon,
} from '@room-match/shared-ui-components';
import { sumArrayOfNumbers, readableAggregates } from '@room-match/shared-utils';
import { Statistics } from 'components/Statistics';
import React from 'react';
import { ROUTES } from 'shared/constants/ROUTES';
import { Body } from './Progress.styles';

type Props = {
  data: any;
};

const Progress: React.FC<Props> = ({ data }) => {
  const countTaskAlerts =
    sumArrayOfNumbers(Object.values(data.aggregates.decisions)) +
    sumArrayOfNumbers(Object.values(data.aggregates.self_tapes)) +
    sumArrayOfNumbers(Object.values(data.aggregates.submissions));

  const submissionsAuditions = Object.entries(data.aggregates.submissions).reduce((acc: any, curr) => {
    const [name, count] = curr;
    const result = acc;
    let icon;
    if (name === 'new') {
      icon = <UserIcon />;
    } else if (name === 'viewed') {
      icon = <ViewedIcon />;
    } else if (name === 'selected') {
      icon = <PointerIcon />;
    } else {
      icon = <CheckedCircleIcon />;
    }
    const newObject: any = {
      count,
      label: readableAggregates(name),
      icon,
    };

    return [...result, newObject];
  }, []);

  const generateTo = (tab: string) => `${ROUTES.CASTING.PROJECT}/${data.id}/self_tapes`;

  const selfTapes = Object.entries(data.aggregates.self_tapes).reduce((acc: any, curr) => {
    const [name, count] = curr;
    const result = acc;

    let newObject: any | undefined;
    if (name === 'approved') {
      newObject = {
        count,
        label: readableAggregates(name),
        icon: <UserBoxIcon />,
        to: generateTo('approved'),
      };
    } else if (name === 'for_review') {
      newObject = {
        count,
        label: readableAggregates(name),
        icon: <MagnifyIcon />,
        to: generateTo('cd-approval'),
      };
    } else if (name === 'requested') {
      newObject = {
        count,
        label: readableAggregates(name),
        icon: <PointerIcon />,
        to: generateTo('requested'),
      };
    }

    return newObject ? [...result, newObject] : result;
  }, []);
  const decisions = Object.entries(data.aggregates.decisions).reduce((acc: any, curr) => {
    const [name, count] = curr;
    const result = acc;
    let icon;
    if (name === 'called_back') {
      icon = <CallBackIcon />;
    } else if (name === 'selects') {
      icon = <SelectedIcon />;
    } else if (name === 'on_avail') {
      icon = <OnAvailIcon />;
    } else if (name === 'released') {
      icon = <TimesCircleIcon />;
    } else if (name === 'booked') {
      icon = <CheckedCalendarIcon />;
    } else {
      icon = <DocumentIcon />;
    }
    const newObject = {
      count,
      label: readableAggregates(name),
      icon,
    };

    return [...result, newObject];
  }, []);
  return (
    <Body container>
      <Grid container>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Box style={{ margin: '5px' }}>
            <Statistics title="Submissions / Auditions" data={submissionsAuditions} status={data.status} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Box style={{ margin: '5px' }}>
            <Statistics title="Self-Tapes" data={selfTapes} status={data.status} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={5}>
          <Box style={{ margin: '5px' }}>
            <Statistics title="Decisions" data={decisions} status={data.status} />
          </Box>
        </Grid>
      </Grid>
    </Body>
  );
};

export default Progress;
